import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../actions'
import NavBar from './NavBar'
import Games from './games/Games'
import ResellerMLBB from '../resellers/games/ResellerMLBB'
import ResellerGame from '../resellers/games/ResellerGame'
import Orders from './orders/Orders'
import Account from '../resellers/account/Account'
import { ENABLE_2FA } from '../../utilities/enable2fa'

let resellerGameDict = {}

const Home = (props) => {
    const [activeItem, setActiveItem] = useState('games')
    const user = useSelector((state) => state.userReseller)
    const { isMobile } = props
    const loginTrigger = useSelector((state) => state.auth.loginTrigger)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.getCurrentUserReseller())
        dispatch(actions.fetchGames('resellers'))
    }, [dispatch, loginTrigger])
    
    if (ENABLE_2FA) if (window.localStorage.getItem('verified2FA') !== 'yup') return
    if (user === undefined || user == null) return
    if (user.name === undefined || user.name == null) return

    const renderContent = () => {
        switch (activeItem) {
            case 'games':
                return <Games gameClicked={handleGameClicked} />
            case 'orders':
                return <Orders/>
            case 'reseller-mlbb':
                return <ResellerMLBB game={resellerGameDict} markup={user.markup} backClicked={handleBackClickedGames} />
            case 'reseller-game':
                return <ResellerGame game={resellerGameDict} markup={user.markup} backClicked={handleBackClickedGames} />
            case 'account':
                return <Account />
            default:
                return
        }
    }

    const handleChangeItemNavBar = (item) => {
        setActiveItem(item)
    }

    const handleGameClicked = (game) => {
        resellerGameDict = game
        if (game.name === 'Mobile Legends') setActiveItem('reseller-mlbb')
        else setActiveItem('reseller-game')
    }

    const handleBackClickedGames = () => {
        setActiveItem('games')
    }
    
    return <div style={{ paddingBottom: 30, background: '#1b1c1d', minHeight: '100vh', color: 'white' }}>
            <NavBar activeItem={activeItem} onChangeItem={handleChangeItemNavBar} isMobile={isMobile} user={user}/>
            {renderContent()}
        </div>
}

export default Home